// Libraries
import { Component, OnInit } from '@angular/core';
import { Router }   from '@angular/router';
// Services
import { SessionService } from '../services/SessionService';
import { UserService } from '../services/UserService';
import { HolidayService } from '../../../../holiday/services/HolidayService';
// Models
import { User } from '../models/User';
import { Parent } from '../../../../holiday/models/Parent';
import { Credential } from '../models/Credential';
import { SessionStorageService } from '../../core/services';

@Component({
    selector: 'user-login',
    template: require('./HolLoginComponent.html'),
    styles: [require('./HolLoginComponent.sass')],
})

export class HolLoginComponent implements OnInit {
    credential:     Credential;
    parent:     Parent;
    message:        string;
    messageType:    string;
    redirectUrl:    string;
    formSubmitted: boolean = false;
    selectedTab: number;
    schools: any;
    hostName: any;
    
    constructor(
        private holidayService: HolidayService,
        private sessionService: SessionService,
        private userService: UserService,
        private router: Router,
        private sessionStorageService: SessionStorageService
    ) {
        this.credential = new Credential('', '', '');
        this.parent = new Parent();
    }

    ngOnInit() {
        this.hostName = window.location.hostname
        // Use Session Service to get session and check if user had already logged in.
        this.getSession();
        this.schools = [
            {
                name: 'Australian International School',
                value: 1,
            },
            {
                name: 'Others',
                value: 2,
            },
        ]
        this.schools.value = 1;
        this.selectedTab = 1;
    };

    onSubmit() {
        this.credential.role = 'parent'
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        this.postSession(this.credential);
    }

    onSubmitNonAis() {
        this.credential.role = 'hol-parent'
        this.formSubmitted = true;
        // Reset message content
        this.message = "";
        // Post user login data to create session
        this.postSessionNonAis(this.credential);
    }

    /**
     * Get Session from API service to make sure that user had logged in.
     * Update User Data on local storage and redirect to the desired URL 
     * if request responses session data.
     * @param none
     * @return none
     */
    private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userService.setUserSessionData(user);
                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }

    /**
     * Post Session to API service to create new session.
     * Update User Data on local storage and redirect to desired URL
     * if request responses session data.
     * @param {Credential} - user credential input
     * @return none
     */

    private postSession(credential: Credential) {
        this.sessionService.postSession(credential)
            .subscribe(
                user    => {
                    this.sessionStorageService.setData('isAisParent', true);
                    // Set user session data
                    this.userService.setUserSessionData(user);
                    // Fire user session data changed event
                    this.userService.userDataChanged(user);
                    this.router.navigate(['/parents'])
                },
                error   => {
                    this.formSubmitted = false;
                    this.message = "Invalid email address or password.";
                    this.messageType = "alert";
                }
            );
    }

    private postSessionNonAis(credential: Credential) {
        this.sessionService.postSession(credential)
            .subscribe(
                user    => {
                    this.sessionStorageService.setData('isAisParent', false);
                    // Set user session data
                    this.userService.setUserSessionData(user);
                    // Fire user session data changed event
                    this.userService.userDataChanged(user);
                    // this.checkStatus();
                    this.router.navigate(['/other-parents'])
                },
                error   => {
                    this.formSubmitted = false;
                    this.message = "Invalid email address or password.";
                    this.messageType = "alert";
                }
            );
    }
    
    toHoliday() {
        switch(this.hostName){
            case "services.aisvietnam.com":
                window.location.href = 'https://holidayschool.aisvietnam.com';
                break;
            case "services.eca.dev.nascorp.vn":
                window.location.href = 'http://holiday.eca.dev.nascorp.vn/';
                break;
            case "services.eca.test.nascorp.vn":
                window.location.href = 'http://holiday.eca.test.nascorp.vn/';
                break;
            case "services.eca.uat.nascorp.vn": 
                window.location.href = 'http://holidayschool.eca.uat.nascorp.vn';
                break;
            case "services.local.eca.dev.nascorp.vn":
                window.location.href = 'http://holiday.local.eca.dev.nascorp.vn';
                break;
        };
    }

    private activateTab(tabId: number) {
        this.selectedTab = tabId;
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/hol-login/HolLoginComponent.ts